module.exports = __webpack_public_path__ + "static/media/ico_switch_camera.ca3d9a2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ico_switch_camera.svg
// module id = 472
// module chunks = 1